export enum MutationTypes {
  SET_ORGANISATIONS = "organisations-module/set-organisations",
  SET_ORGANISATIONS_FOR_CSV = "organisations-module/set-organisations-for-csv",
  SET_ORGANISATIONS_META = "organisations-module/set-organisations-meta",
}
